import { CALL_CENTER_PHONE } from '@/js/helpers/globalConst';

const isEmpty = value => (typeof value === 'undefined' || value === null || value === '');

function street(value) {
  if (isEmpty(value)) {
    return true;
  }
  return !/[^(а-яА-ЯЁёa-zA-Z0-9\-\s)]/.test(value);
}

function house(value) {
  if (isEmpty(value)) {
    return true;
  }
  return /^[а-яА-ЯЁёa-zA-Z0-9]+$/.test(value);
}

function minDate(min) {
  return (value) => {
    if (isEmpty(value)) {
      return true;
    }
    return +min <= +new Date(value);
  };
}

function notCyrillic(value) {
  if (isEmpty(value)) {
    return true;
  }
  return !/[а-яА-ЯЁё]/.test(value);
}

function personName(value) {
  if (isEmpty(value)) {
    return true;
  }
  // https://bit.ly/2YkfW2I ссылка на regexper.com где можно посмотреть визуально работу выражения
  return /^([а-яА-ЯЁёa-zA-Z]+-?[а-яА-ЯЁёa-zA-Z]+)\s([а-яА-ЯЁёa-zA-Z]+-?[а-яА-ЯЁёa-zA-Z]+)\s?([а-яА-ЯЁёa-zA-Z]+)?$/.test(value);
}

function fullName(value) {
  if (isEmpty(value)) {
    return true;
  }
  return value.split(' ').filter(word => word).length >= 2;
}

function phone(value) {
  if (isEmpty(value)) {
    return true;
  }
  return !/[^(0-9+\-\s())]/.test(value);
}

function phoneMinLength(value) {
  if (isEmpty(value)) {
    return true;
  }
  const length = value.length;
  return length > 10;
}

function inn(value) {
  if (isEmpty(value)) {
    return true;
  }

  const length = value.length;
  return length === 10 || length === 12;
}

function kpp(value) {
  if (isEmpty(value)) {
    return true;
  }
  return (value.length === 1 && value === '0') || value.length === 9;
}

function bik(value) {
  if (isEmpty(value)) {
    return true;
  }
  return value.length === 9;
}

function account(value) {
  if (isEmpty(value)) {
    return true;
  }
  return value.length === 20;
}

function fio(value) {
  if (isEmpty(value)) {
    return true;
  }

  const words = value.split(' ');
  const filledWords = words.filter(word => !!word);

  return filledWords.length === 3;
}

function postIndex(value) {
  return !!value;
}

function dhlIndex(value) {
  return !!value;
}

function number(value) {
  if (isEmpty(value)) {
    return true;
  }
  return value.length <= 15;
}

function firstEmailSymbols(value) {
  if (isEmpty(value)) {
    return true;
  }
  return /^[a-zA-Z0-9]/.test(value);
}

function organizationNameLength(value) {
  if (isEmpty(value)) {
    return true;
  }
  return value.length <= 100;
}

const checkName = (value) => {
  if (isEmpty(value)) {
    return true;
  }
  return !/[^(а-яА-ЯЁёa-zA-Z\-\s)]/.test(value);
};

const checkLength = (value) => {
  if (isEmpty(value)) {
    return true;
  }
  return value.length > 1;
};

const checkPhoneForForeign = (value) => {
  const numbersValue = value.replace(/\D/g, '');
  const regExp = /[a-zA-Z]/g;
  const hasLetters = regExp.test(value);
  const hasPlusSymbol = value[0] === '+';
  const hasEnableNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(Number(numbersValue[1]));
  return (hasPlusSymbol && hasEnableNumber && !hasLetters);
};

const checkPhone = (value) => {
  const numbersValue = value.replace(/\D/g, '');
  return numbersValue.length === 11 || (numbersValue.length < 11 && numbersValue === '8');
};

const checkPhoneForRu = (value) => {
  const numbersValue = value.replace(/\D/g, '');
  const hasNineNumber = Number(numbersValue[1]) === 9;
  return ((numbersValue.length === 11 && hasNineNumber) || (numbersValue.length === 1 && numbersValue === '8'));
};

const checkCallCenter = (value) => {
  const arrayMatches = CALL_CENTER_PHONE.filter(item => item === value);
  return !arrayMatches.length;
};

export {
  street,
  house,
  minDate,
  notCyrillic,
  personName,
  phone,
  phoneMinLength,
  inn,
  kpp,
  bik,
  account,
  fio,
  postIndex,
  dhlIndex,
  fullName,
  number,
  organizationNameLength,
  firstEmailSymbols,
  checkName,
  checkLength,
  checkPhone,
  checkCallCenter,
  checkPhoneForForeign,
  checkPhoneForRu,
};
